<script setup>
import { useGlobalStore } from '@/stores/global'
import { ref } from 'vue'

import Button from './Button.vue'
import MobileMenu from './MobileMenu.vue'

const global = useGlobalStore()
const isScrolled = ref(false)
const links = ref([
	{
		title: 'Overview',
		hash: '#overview',
	},
	// {
	//     title: 'Schedule',
	//     hash: '#schedule'
	// },
	{
		title: 'Prizing',
		hash: '#prizing',
	},
	{
		title: 'Donate',
		hash: '#donate',
	},
])

function toggleMobile() {
	isMobile.value = !isMobile.value
}

function scroll() {
	let scrollPosition = window.scrollY
	if (scrollPosition >= 80) {
		isScrolled.value = true
	} else {
		isScrolled.value = false
	}
}
window.addEventListener('scroll', scroll)
</script>

<template>
	<header :class="['fixed left-0 top-0 z-50 flex h-20 w-full items-center bg-carbon-200/80 text-white transition-all duration-500', { scrolled: isScrolled }]">
		<div class="container">
			<div class="flex items-center justify-between">
				<router-link :to="{ name: 'index' }">
					<img :class="['h-10 transition-all duration-500 lg:h-12', { 'h-8 lg:h-10': isScrolled }]" src="https://d1f3y6u6f3nh06.cloudfront.net/images/logos/logitechadaptive.svg" alt="Logitech Adaptive Esports Tournaments Logo" />
				</router-link>
				<nav :class="['hidden items-center gap-8 text-sm font-bold uppercase transition-all duration-500 lg:flex', { 'text-xs': isScrolled }]">
					<router-link class="transition-colors hover:text-white/50" :to="{ name: 'index', hash: link.hash }" v-for="(link, i) in links" :key="i">{{ link.title }}</router-link>
					<Button href="https://docs.google.com/forms/d/1jPCVRXX15kLNOu9910QXpjmMF0mgVM8PylAWHbEVLfg/viewform?edit_requested=true" class="btn-small">Apply Now</Button>
				</nav>
				<button class="flex h-8 w-8 items-center justify-center lg:hidden" @click="global.toggleMobile()">
					<i class="fa-solid fa-xmark-large text-xl transition-all" v-if="global.mobile"></i>
					<i class="fa-solid fa-bars text-xl transition-all" v-else></i>
				</button>
			</div>
		</div>
	</header>
	<transition name="fade">
		<MobileMenu :links="links" v-if="global.mobile" />
	</transition>
</template>

<style scoped>
.scrolled {
	@apply h-16;
}
</style>
